export default "__VITE_ASSET__5OA12cJA__"